import App from './App.vue';
import Vue from 'vue';
import VTooltip from 'v-tooltip';
import VueScrollTo from 'vue-scrollto';
import Vue2TouchEvents from 'vue2-touch-events';
import './helpers/helper';

if (document.getElementById('vue-mortgage-calc')) {
    Vue.config.productionTip = false;
    Vue.config.devtools = true;

    const optionsTooltip = {
        defaultTemplate: '<div class="vue-tooltip" role="tooltip"><div class="vue-tooltip__arrow"></div><div class="vue-tooltip__inner"></div></div>',
        defaultArrowSelector: '.vue-tooltip__arrow',
        defaultInnerSelector: '.vue-tooltip__inner',
        defaultArrowClass: 'tooltip-arrow popover-arrow',
        popover: {
            defaultPlacement: 'top',
            defaultBaseClass: 'vue-tooltip vue-popover',
            defaultInnerClass: 'vue-tooltip__inner vue-popover__inner',
            defaultArrowClass: 'vue-tooltip__arrow vue-popover__arrow',
        }
    };

    const optionsScroll = {
        container: "body",
        duration: 500,
        offset: 0,
        cancelable: false
    };

    Vue.use(VTooltip, optionsTooltip);
    Vue.use(VueScrollTo, optionsScroll);
    Vue.use(Vue2TouchEvents, {
        disableClick: true,
        touchClass: '',
        tapTolerance: 10,
        touchHoldTolerance: 400,
        swipeTolerance: 30,
        longTapTimeInterval: 400,
        namespace: 'touch'
    });

    Vue.prototype.$dataset = document.getElementById('vue-mortgage-calc').dataset;

    new Vue({
        render: (h) => {
            return h(App);
        }
    }).$mount('#vue-mortgage-calc');
}
